import * as React from 'react';
import { styled } from '../../../core/theme/styled';

type ErrorLabelProps = {
  isError: boolean;
  message: string;
};

export const Caption = styled(({ message, isError, ...rest }) => {
  return (
    <div data-testid="message" {...rest}>
      {message}
    </div>
  );
})<ErrorLabelProps>`
  white-space: pre-wrap;
  color: ${(props) =>
    props.isError
      ? props.theme.configuration.errorTextColor
      : props.theme.configuration.secondaryTextColor};
  margin-top: ${(props) => props.theme.sizes.xxsmall};

  font-size: ${(props) => props.theme.typography.caption.fontSize};
  line-height: ${(props) => props.theme.typography.caption.lineHeight};
`;
